import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { DealerOnly, dashboardCardSx } from '../common';
import { useDashboardRange } from './DashboardRangeContext';
import { useRangeDealerStatistics } from './useRecentDealerStatistics';

const BAR_MAX_HEIGHT = 96;
const WEEKDAYS = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'];

/** Sums accidents of the selected range by day of the week (Monday first). */
const WeekActivityWidgetConnectedContent = () => {
  const { days, counts, isLoading } = useRangeDealerStatistics();
  const { label } = useDashboardRange();

  const totals = WEEKDAYS.map(() => 0);
  days.forEach((day, index) => {
    totals[(day.getDay() + 6) % 7] += counts[index]?.total ?? 0;
  });
  const total = totals.reduce((sum, value) => sum + value, 0);
  const maxValue = Math.max(...totals, 1);
  const busiestIndex = total > 0 ? totals.indexOf(Math.max(...totals)) : -1;

  return (
    <Box
      sx={{
        ...dashboardCardSx,
        height: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        padding: { xs: 2, md: 3 }
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Stack>
          <Typography variant="h6" fontWeight={600}>
            Podle dne v týdnu
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        </Stack>
        {isLoading ? (
          <Skeleton variant="rounded" width={48} height={40} />
        ) : (
          <Typography sx={{ fontSize: '2rem', fontWeight: 700, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>
            {total}
          </Typography>
        )}
      </Stack>
      <Stack direction="row" alignItems="flex-end" justifyContent="space-between" gap={1} sx={{ mt: 'auto' }}>
        {WEEKDAYS.map((weekday, index) => {
          const busiest = index === busiestIndex;
          return (
            <Stack key={weekday} alignItems="center" gap={1} sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="body2" fontWeight={600} sx={{ fontVariantNumeric: 'tabular-nums' }}>
                {isLoading ? '' : totals[index]}
              </Typography>
              <Box
                sx={{
                  width: 1,
                  maxWidth: 36,
                  height: isLoading ? 4 : Math.max(4, Math.round((totals[index] / maxValue) * BAR_MAX_HEIGHT)),
                  borderRadius: 1,
                  backgroundColor: busiest ? 'primary.main' : 'rgba(198, 35, 39, 0.22)',
                  '@media (prefers-reduced-motion: no-preference)': {
                    transition: 'height 0.5s cubic-bezier(0.16, 1, 0.3, 1)'
                  }
                }}
              />
              <Typography
                variant="body2"
                fontWeight={busiest ? 700 : 500}
                color={busiest ? 'primary.main' : 'text.secondary'}
              >
                {weekday}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
};

export const WeekActivityWidgetConnected = () => (
  <DealerOnly>
    <WeekActivityWidgetConnectedContent />
  </DealerOnly>
);
